// extracted by mini-css-extract-plugin
export default {"tab-bar":"TabBar_tab-bar__ajmOb","tab-bar_view-transparent":"TabBar_tab-bar_view-transparent__Yiw+B","tab-bar_view-filled":"TabBar_tab-bar_view-filled__ligj+"};